// extracted by mini-css-extract-plugin
module.exports = {"literatureWrapper":"Literature_view_literatureWrapper__VGPxC"};